import ServicesOverview from '../ServicesOverview';
import PricingSection from '../PricingSection';
import PricingComparisonTable from '../PricingComparisonTable';
import AIIntegration from '../AIIntegration';

const ProductPage = () => (
  <div className="page-content">
      <ServicesOverview />
      <PricingSection />
      <PricingComparisonTable />
    <AIIntegration title='Build Smarter, Scale Faster: The Future of Data Platforms Is Here' description='Unlock the power of AI-driven insights. From seamless data ingestion to advanced analytics and machine learning, empower every team to make faster, smarter decisions—governed, scalable, and instantly deployable in the cloud.' />
    </div>
);

export default ProductPage;
